import { useEffect } from "react";
import { Routes, Route, useMatch } from "react-router-dom";
import Home from "./pages/Index";
import LicenseMaker from "./pages/LicenseMaker";
import {  scrollY_to_target } from "./utills/utills";

function Router() {
  const downlaod = useMatch("/download");
  const guide = useMatch("/guide");
  const price = useMatch("/price");
  const contact = useMatch("/contact");
  
  useEffect(() => {
    downlaod && scrollY_to_target("download");
    guide && scrollY_to_target("guide");
    price && scrollY_to_target("price");
    contact && scrollY_to_target("contact");
  }, [downlaod, guide, price, contact]);

  return (
    <>
      <Routes>
        <Route path={`/license_maker`} element={<LicenseMaker />} />
        <Route path={`/*`} element={<Home />} />
      </Routes>
    </>
  );
}

export default Router;
